/**
 * Client Runtime Mod 定义
 *
 * client-runtime-mod 的运行时定义，消费 Registry 数据并驱动渲染。
 *
 * 内置 react-router-adapter 作为默认路由实现。
 * 提供两个服务：
 * - routerAdapter: IRouterAdapter 的 react-router 实现
 * - clientRuntime: 运行时主体，消费注册数据驱动渲染
 */
import { ROUTER_ADAPTER_INTERFACE_TAG, PAGE_ROUTE_REGISTRY_INTERFACE_TAG, GLOBAL_STATE_REGISTRY_INTERFACE_TAG, COMPONENT_REGISTRY_INTERFACE_TAG, HOOKS_REGISTRY_INTERFACE_TAG, CLIENT_SERVICE_REGISTRY_INTERFACE_TAG, } from '@hvsin/ui-registry-contracts';
import { ReactRouterAdapter } from './react-router-adapter.js';
import { ClientRuntime } from './client-runtime.js';
/**
 * ClientRuntime 的构造器 — 封装依赖注入
 */
class ClientRuntimeImpl {
    constructor(deps) {
        return new ClientRuntime(deps);
    }
}
/**
 * client-runtime-mod 定义
 *
 * 运行时层，依赖 React + react-router-dom + jotai。
 * 无需声明对业务 Mod 的依赖——事件机制保证渲染时序。
 *
 * 使用方式：
 * ```typescript
 * import { clientRuntimeMod } from '@hvsin/mod-client-runtime'
 *
 * await container.loadMods([clientRuntimeMod, ...businessMods])
 * ```
 */
export const clientRuntimeMod = {
    name: 'client-runtime',
    modDependencies: ['ui-registry'],
    serviceDefs: [
        {
            serviceTag: 'routerAdapter',
            serviceImpl: ReactRouterAdapter,
            serviceInterfaceTag: ROUTER_ADAPTER_INTERFACE_TAG,
        },
        {
            serviceTag: 'clientRuntime',
            serviceImpl: ClientRuntimeImpl,
            dependencies: [
                PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
                GLOBAL_STATE_REGISTRY_INTERFACE_TAG,
                COMPONENT_REGISTRY_INTERFACE_TAG,
                HOOKS_REGISTRY_INTERFACE_TAG,
                CLIENT_SERVICE_REGISTRY_INTERFACE_TAG,
            ],
        },
    ],
};
//# sourceMappingURL=mod.js.map